/**
 * Precios de Hunting en puntos (2026-10-21). El backend los manda en `pricing`
 * (serviceConfig.HUNTING_UNIT_COSTS); esto es el respaldo para cuando no
 * llegan, por ejemplo en el inicio, antes de buscar. Cada email cuesta 1/17
 * de punto y cada teléfono 1/2; en pantalla se muestra el valor calculado con
 * 2 decimales (0.06 y 0.50), y los totales se calculan con el valor exacto.
 */
export const DEFAULT_PRICING = { email: 1 / 17, phone: 1 / 2 };

export const fmtPoints = (n) => (Math.round((Number(n) || 0) * 100) / 100).toFixed(2);
